import { useCallback, useContext } from 'react';
import en from './en.json';
import hi from './hi.json';
import type { Lang } from '../types';
import { useApp } from '../context/AppContext';
import { TermContext, type PersonTerm } from '../context/TermContext';

type Dict = Record<string, unknown>;
const dicts: Record<Lang, Dict> = { en, hi };

export type TFn = (key: string, vars?: Record<string, string | number>) => string;

function lookup(d: Dict, key: string): string | undefined {
  const v = key.split('.').reduce<unknown>((o, k) => (o && typeof o === 'object' ? (o as Dict)[k] : undefined), d);
  return typeof v === 'string' ? v : undefined;
}

const TERM_KEYS = ['person', 'Person', 'people', 'People', 'peopleObl', 'List'];

/** {person} / {people} etc. come from the clinic's programme (mother or patient), unless the caller passes them. */
export function translate(lang: Lang, key: string, vars?: Record<string, string | number>, term: PersonTerm = 'mother'): string {
  let s = lookup(dicts[lang], key) ?? lookup(dicts.en, key) ?? key;
  if (vars) Object.entries(vars).forEach(([k, v]) => (s = s.split(`{${k}}`).join(String(v))));
  if (s.includes('{')) TERM_KEYS.forEach((k) => { if (s.includes(`{${k}}`)) s = s.split(`{${k}}`).join(lookup(dicts[lang], `term.${term}.${k}`) ?? lookup(dicts.en, `term.${term}.${k}`) ?? ''); });
  return s;
}

export function useT(): TFn {
  const { lang } = useApp();
  const term = useContext(TermContext);
  return useCallback((key, vars) => translate(lang, key, vars, term), [lang, term]);
}
